import { Modal } from 'tt-ui-lib/core';
import styles from './VerifyEmailModal.module.scss';

const VerifyEmailModal = ({
  isModelOpen,
  setIsOpen,
  handleClose,
  title,
  text,
  subText,
  isDashboard = false,
}) =>
  isDashboard ? (
    <Modal
      closable={false}
      open={isModelOpen}
      // onClose={() => handleClose(setIsOpen)}
      title={title}
    >
      <div className={styles.dashboardModalBody}>
        <div className={styles.text}>{text}</div>
        <div className={styles.text}>{subText}</div>
      </div>
    </Modal>
  ) : (
    <Modal
      closable={false}
      open={isModelOpen}
      // onClose={() => handleClose(setIsOpen)}
      title={title}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div className={styles.text}>{text}</div>
        <div className={styles.text}>{subText}</div>
      </div>
    </Modal>
  );

export default VerifyEmailModal;
